import { render, staticRenderFns } from "./c-columns-with-template-field.vue?vue&type=template&id=04eb23db&"
import script from "./c-columns-with-template-field.vue?vue&type=script&lang=js&"
export * from "./c-columns-with-template-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports